/* STOPI theme scripts — works with every stopi-* section (idempotent, theme-editor friendly) */
(function () {
  if (window.__stopiLoaded) { return; }
  window.__stopiLoaded = true;

  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = matchMedia('(hover:hover) and (pointer:fine)').matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };

  /* ---------- videos: load lazily, play only while visible, always muted ---------- */
  function load(v) {
    if (!v.play) { return; }
    if (v.dataset.src && !v.getAttribute('src')) { v.src = v.dataset.src; v.load(); }
  }
  var visible = [];
  function play(v) {
    if (!v.play) { return; }
    v.muted = true; v.defaultMuted = true;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
    load(v);
    var p = v.play();
    if (p && p.catch) { p.catch(function () {}); }
  }
  /* mobile browsers may refuse autoplay until the first touch/scroll: retry then, and when data arrives */
  function retryVisible() { visible.forEach(function (v) { if (v.paused && !reduce) { play(v); } }); }
  ['touchstart', 'pointerdown', 'scroll', 'click'].forEach(function (ev) { addEventListener(ev, retryVisible, { passive: true, capture: true }); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) { retryVisible(); } });
  var vio = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var v = e.target;
      if (v.closest('[data-stage]')) { return; }
      var at = visible.indexOf(v);
      if (e.isIntersecting) { if (at < 0) { visible.push(v); } load(v); if (!reduce) { play(v); } } else { if (at > -1) { visible.splice(at, 1); } v.pause(); }
    });
  }, { rootMargin: '200px', threshold: 0.15 });

  /* ---------- reveal + counters ---------- */
  var rio = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); rio.unobserve(e.target); } });
  }, { threshold: 0.12 });

  function count(el) {
    var t = +el.dataset.count, s = el.dataset.suffix || '';
    if (reduce) { el.textContent = t + s; return; }
    var st = null;
    (function step(ts) {
      if (!st) { st = ts; }
      var p = Math.min(1, (ts - st) / 1500);
      el.textContent = Math.floor(t * (1 - Math.pow(1 - p, 3))) + s;
      if (p < 1) { requestAnimationFrame(step); }
    })(performance.now());
  }
  var cio = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { count(e.target); cio.unobserve(e.target); } });
  }, { threshold: 0.6 });

  /* ---------- lightbox (videos open full screen, muted) ---------- */
  var lb, lbv;
  function ensureLightbox() {
    if (lb) { return; }
    lb = document.createElement('div');
    lb.className = 'stopi stopi-lightbox';
    lb.innerHTML = '<span class="lb-x" aria-label="Затвори">×</span><video muted loop playsinline autoplay></video>';
    document.body.appendChild(lb);
    lbv = lb.querySelector('video');
    lb.addEventListener('click', function (e) { if (e.target !== lbv) { closeLb(); } });
    addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeLb(); } });
  }
  function openLb(src) {
    ensureLightbox();
    lbv.src = src; lbv.muted = true;
    lb.classList.add('open');
    var p = lbv.play(); if (p && p.catch) { p.catch(function () {}); }
  }
  function closeLb() {
    if (!lb) { return; }
    lb.classList.remove('open'); lbv.pause(); lbv.removeAttribute('src'); lbv.load();
  }

  /* ---------- section initialisers ---------- */
  function initPicker(root) {
    var tabs = $$('.tab', root), vids = $$('.pk-v', root), infos = $$('.pk-info', root), stage = $('[data-stage]', root);
    if (!tabs.length) { return; }
    var cur = 0, visible = false;
    function pick(i) {
      cur = i;
      tabs.forEach(function (t, k) { t.setAttribute('aria-selected', k === i); });
      vids.forEach(function (v, k) { v.classList.toggle('on', k === i); if (k !== i && v.pause) { v.pause(); } });
      infos.forEach(function (n, k) { n.classList.toggle('on', k === i); });
      if (vids[i]) { if (visible && !reduce) { play(vids[i]); } else { load(vids[i]); } }
    }
    tabs.forEach(function (t, k) { t.addEventListener('click', function () { pick(k); }); });
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        visible = e.isIntersecting;
        if (vids[cur]) { if (visible && !reduce) { play(vids[cur]); } else if (vids[cur].pause) { vids[cur].pause(); } }
      });
    }, { threshold: 0.25 }).observe(stage);
    pick(0);
  }

  function initReviewModal(root) {
    var modal = $('.modal', root), open = $('[data-rev-open]', root);
    if (!modal || !open) { return; }
    var pickWrap = $('.star-pick', modal), rating = 5, form = $('form', modal);
    function paint(n) { $$('button', pickWrap).forEach(function (b) { b.classList.toggle('on', +b.dataset.v <= n); }); }
    paint(rating);
    $$('button', pickWrap).forEach(function (b) { b.addEventListener('click', function () { rating = +b.dataset.v; paint(rating); }); });
    open.addEventListener('click', function () { modal.classList.add('open'); });
    $('.modal-x', modal).addEventListener('click', function () { modal.classList.remove('open'); });
    modal.addEventListener('click', function (e) { if (e.target === modal) { modal.classList.remove('open'); } });
    addEventListener('keydown', function (e) { if (e.key === 'Escape') { modal.classList.remove('open'); } });
    if (form) {
      form.addEventListener('submit', function () {
        var body = $('[name="contact[body]"]', form);
        var prod = $('[name="stopi_product"]', form), txt = $('[name="stopi_text"]', form);
        body.value = 'НОВО РЕВЮ\nОценка: ' + rating + '/5\nПродукт: ' + (prod ? prod.value : '') + '\n\n' + (txt ? txt.value : '');
      });
    }
    if ($('.modal-note.ok', modal)) { modal.classList.add('open'); }
  }

  function initRevCarousel(el) {
    var timer = null, paused = false;
    function step() {
      var cards = $$('.rev', el); if (cards.length < 2) { return; }
      var w = cards[0].getBoundingClientRect().width + 16;
      var end = el.scrollLeft + el.clientWidth >= el.scrollWidth - 4;
      el.scrollTo({ left: end ? 0 : el.scrollLeft + w, behavior: 'smooth' });
    }
    function start() { if (reduce || timer) { return; } timer = setInterval(function () { if (!paused) { step(); } }, 4500); }
    ['pointerenter', 'touchstart', 'focusin'].forEach(function (ev) { el.addEventListener(ev, function () { paused = true; }, { passive: true }); });
    ['pointerleave', 'touchend', 'focusout'].forEach(function (ev) { el.addEventListener(ev, function () { setTimeout(function () { paused = false; }, 1500); }, { passive: true }); });
    new IntersectionObserver(function (es) { es.forEach(function (e) { paused = !e.isIntersecting; }); }, { threshold: 0.2 }).observe(el);
    start();
  }

  function initOnce(el, key, fn) { var k = '__stopi_' + key; if (el[k]) { return; } el[k] = true; fn(el); }

  function init() {
    $$('.stopi video[data-stopi-video], .stopi video.hero-vid').forEach(function (v) {
      v.muted = true; v.defaultMuted = true;
      initOnce(v, 'video', function () {
        vio.observe(v);
        v.addEventListener('loadeddata', function () { if (visible.indexOf(v) > -1 && v.paused && !reduce) { play(v); } });
        v.addEventListener('stalled', function () { if (visible.indexOf(v) > -1 && v.paused) { play(v); } });
        if (v.closest('.reel')) { v.addEventListener('click', function () { if (v.paused) { play(v); } }); }
      });
    });
    $$('.stopi .rv').forEach(function (el, i) {
      initOnce(el, 'rv', function () { el.style.transitionDelay = (i % 4) * 70 + 'ms'; rio.observe(el); });
    });
    $$('.stopi [data-count]').forEach(function (el) { initOnce(el, 'count', function () { cio.observe(el); }); });
    $$('.stopi [data-picker]').forEach(function (el) { initOnce(el, 'picker', initPicker); });
    $$('[data-reviews]').forEach(function (el) { initOnce(el, 'reviews', initReviewModal); });
    $$('[data-rev-carousel]').forEach(function (el) { initOnce(el, 'revcar', initRevCarousel); });

    $$('.stopi .clip[data-full]').forEach(function (c) {
      initOnce(c, 'clip', function () { c.addEventListener('click', function () { openLb(c.dataset.full); }); });
    });
    $$('.stopi [data-bubble]').forEach(function (b) {
      initOnce(b, 'bubble', function () { b.addEventListener('click', function () { openLb(b.dataset.full); }); });
    });
    $$('.stopi .card, .stopi .stage').forEach(function (el) {
      initOnce(el, 'gloss', function () {
        el.addEventListener('pointermove', function (e) {
          var r = el.getBoundingClientRect();
          el.style.setProperty('--mx', (e.clientX - r.left) + 'px');
          el.style.setProperty('--my', (e.clientY - r.top) + 'px');
        });
      });
    });
    onScroll();
  }

  /* ---------- scroll: progress bar + floating bubble ---------- */
  var bar;
  function onScroll() {
    if (!document.querySelector('.stopi')) { return; }
    if (!bar) {
      var w = document.createElement('div');
      w.className = 'stopi';
      w.innerHTML = '<div class="progress"></div>';
      document.body.appendChild(w);
      bar = w.firstChild;
    }
    var h = document.documentElement;
    bar.style.transform = 'scaleX(' + Math.min(1, h.scrollTop / (h.scrollHeight - h.clientHeight || 1)) + ')';
    $$('[data-bubble]').forEach(function (b) { b.classList.toggle('show', h.scrollTop > 700); });
  }
  addEventListener('scroll', onScroll, { passive: true });

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
